<template>
  <b-modal
    modal-class="unlock-modal"
    v-model="editorShown"
    title="Notice of Data Integrity"
    size="md"
    centered
    no-close-on-backdrop
  >
    <p style="font-size:13px;">
      As a user of Opus EHR, I acknowledge that I am responsible for all
      information I input into Opus EHR, including changes made to locked
      documents. I understand and agree that I am bound by various laws and
      regulations, including but not limited to HIPAA and professional ethics,
      which require that I preserve the availability, accuracy, integrity, and
      confidentiality of protected health information. I unconditionally
      release, discharge, and indemnify Opus EHR from any liability arising out
      of any changes made to a locked and signed document. I also understand and
      agree that all of my activity within Opus EHR is automatically logged,
      including the unlocking and changes to this document, and that my activity
      may be audited by account owners, account administrators, regulators, or
      others.
    </p>
    <b-form-group
      label="Reason for unlocking"
      :state="reasonErrors.length == 0 ? null : false"
      :invalid-feedback="reasonErrors.join(', ')"
    >
      <template v-slot:label="">
        Reason for unlocking
        <span class="text-danger">*</span>
      </template>
      <b-form-input
        placeholder=""
        v-model="reason"
        trim
        :state="reasonErrors.length == 0 ? null : false"
      ></b-form-input>
    </b-form-group>
    <template v-slot:modal-footer>
      <button
        @click="handleDismiss"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        Cancel
      </button>
      <b-button @click="handleConfirm" variant="danger">
        Accept & Unlock
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { validateRequired } from "../../helpers/validation";
export default {
  name: "DialogUnlockDocument",
  data() {
    return {
      reason: "",
      reasonErrors: []
    };
  },
  methods: {
    handleConfirm() {
      this.reasonErrors = [];
      if (!validateRequired(this.reason)) {
        this.reasonErrors.push("This field is required");
        return;
      }
      this.$emit("confirm", { reason: this.reason }); // included in DialogMixin
    },
    handleDismiss() {
      this.$emit("cancel"); // included in DialogMixin
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
